import { useId } from 'react'

/**
 * กล่องของขวัญทอง (ริบบิ้นแดง) — แยกตัวกล่อง/ฝาได้ เพื่อให้ฝากระเด็นตอนเปิดกล่องกลางจอ
 * part ไม่ระบุ = วาดทั้งกล่อง (ใช้เป็นป้ายเล็กเกาะข้างถุงทองที่มุมจอ)
 */
export function GiftBoxIcon({ className = '', part }: { className?: string; part?: 'body' | 'lid' }) {
  const uid = useId().replace(/:/g, '')
  const box = `gift-box-${uid}`
  const ribbon = `gift-ribbon-${uid}`
  return (
    <svg className={className} viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={box} x1="0" y1="0" x2="1" y2="1"><stop stopColor="#fff2c9" /><stop offset=".35" stopColor="#e2c37a" /><stop offset=".7" stopColor="#b08a45" /><stop offset="1" stopColor="#6b4c22" /></linearGradient>
        <linearGradient id={ribbon} x1="0" y1="0" x2="1" y2="0"><stop stopColor="#7a1426" /><stop offset=".5" stopColor="#c8344d" /><stop offset="1" stopColor="#7a1426" /></linearGradient>
      </defs>
      {part !== 'lid' && <g>
        <rect x="16" y="46" width="88" height="68" rx="6" fill={`url(#${box})`} stroke="#6b4c22" strokeWidth="1.5" />
        <rect x="52" y="46" width="16" height="68" fill={`url(#${ribbon})`} />
        <rect x="16" y="46" width="88" height="8" fill="#6b4c22" opacity=".25" />
        <path d="M24 60 L24 104" stroke="#fffbea" strokeWidth="2.5" strokeLinecap="round" opacity=".6" />
      </g>}
      {part !== 'body' && <g>
        <path d="M60 32 C48 12 30 12 32 24 C34 33 50 33 60 32 Z" fill={`url(#${ribbon})`} stroke="#5c0e1c" strokeWidth="1.2" />
        <path d="M60 32 C72 12 90 12 88 24 C86 33 70 33 60 32 Z" fill={`url(#${ribbon})`} stroke="#5c0e1c" strokeWidth="1.2" />
        <rect x="10" y="30" width="100" height="20" rx="5" fill={`url(#${box})`} stroke="#6b4c22" strokeWidth="1.5" />
        <rect x="52" y="30" width="16" height="20" fill={`url(#${ribbon})`} />
        <circle cx="60" cy="32" r="6" fill="#c8344d" stroke="#5c0e1c" strokeWidth="1.2" />
        <path d="M18 36 L46 36" stroke="#fffbea" strokeWidth="2.5" strokeLinecap="round" opacity=".7" />
      </g>}
    </svg>
  )
}
